import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const adminAuthApi = createApi({
  reducerPath: 'adminAuthApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/auth' }),
  endpoints: (builder) => ({
    sendOtp: builder.mutation({
      query: ({ email, password, deviceId, role }) => ({
        url: '/register',
        method: 'POST',
        body: { email, password, deviceId, role },
      }),
    }),
    verifyOtp: builder.mutation({
      query: ({ email, otp, deviceId }) => ({
        url: '/verify-otp',
        method: 'POST',
        body: { email, otp, deviceId },
      }),
    }),
  }),
});

export const { useSendOtpMutation, useVerifyOtpMutation } = adminAuthApi;
